import { Routes, Route, useNavigate } from 'react-router-dom';
import { GalleryList } from './components/GalleryList';
import { GalleryDetail } from './components/GalleryDetail';
import { CreateGallery } from './components/CreateGallery';

/**
 * Visual Galleries Main Component
 * 
 * This component manages the Visual Galleries feature within Asset Management.
 * It provides functionality to:
 * - List and filter galleries by location and program
 * - Create new galleries for villages/districts/programs
 * - Manage gallery assets and their sequence
 * - Activate/deactivate galleries
 * 
 * Role-based access:
 * - GALLERY.VIEWER: Can view galleries and assets
 * - GALLERY.MODERATOR: Can create, update galleries and manage assets
 */
export const VisualGalleries = () => {
  const navigate = useNavigate();

  // Handle navigation between different gallery views
  const handleNavigateToCreate = () => {
    navigate('/asset-management/galleries/create');
  };

  const handleNavigateToDetail = (galleryId: number) => {
    navigate(`/asset-management/galleries/${galleryId}`);
  };

  const handleNavigateToList = () => {
    navigate('/asset-management/galleries');
  };

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="bg-white shadow-sm border border-rgf-gray-200 rounded-lg p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-rgf-gray-900">Visual Galleries</h1>
            <p className="mt-2 text-sm text-rgf-gray-600">
              Create and manage visual galleries to showcase program impact by location
            </p>
          </div>
        </div>
      </div>

      {/* Routes */}
      <Routes>
        <Route 
          path="/" 
          element={
            <GalleryList 
              onCreateClick={handleNavigateToCreate}
              onGalleryClick={handleNavigateToDetail}
            />
          } 
        />
        <Route 
          path="/create" 
          element={
            <CreateGallery 
              onSuccess={handleNavigateToList}
              onCancel={handleNavigateToList}
            />
          } 
        />
        <Route 
          path="/:galleryId" 
          element={
            <GalleryDetail 
              onBackClick={handleNavigateToList}
            />
          } 
        />
      </Routes>
    </div>
  );
};